import { useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Building2, Layers, TerminalSquare, LogOut, Crown, TicketPercent, GraduationCap, DatabaseBackup } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLayout } from "@/context/LayoutContext";
import { getTenantSlug, setTenantSlug } from "@/lib/tenant";

const NAV = [
  { to: "/master", label: "Clientes", icon: Building2, end: true, id: "tenants" },
  { to: "/master/plans", label: "Planos", icon: Layers, id: "plans" },
  { to: "/master/coupons", label: "Cupons", icon: TicketPercent, id: "coupons" },
  { to: "/master/tutorial", label: "Tutorial e suporte", icon: GraduationCap, id: "tutorial" },
  { to: "/master/automation", label: "Automação", icon: TerminalSquare, id: "automation" },
  { to: "/master/backup", label: "Backup", icon: DatabaseBackup, id: "backup" },
];

export default function MasterShell() {
  const { user, logout } = useAuth();
  const { refetch } = useLayout();
  useEffect(() => {
    if (getTenantSlug()) { setTenantSlug(null); refetch(); }
  }, [refetch]);
  return (
    <div className="min-h-screen" style={{ background: "var(--surface-alt)" }}>
      <header className="sticky top-0 z-30 border-b" style={{ background: "var(--surface)", borderColor: "var(--border)" }}>
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center gap-4">
          <div className="flex items-center gap-2 shrink-0" data-testid="master-brand">
            <span className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: "var(--text)", color: "var(--surface)" }}><Crown size={18} /></span>
            <div className="leading-tight hidden sm:block"><div className="label">Painel Master</div><div className="caption">Plataforma CMV</div></div>
          </div>
          <nav className="flex gap-1 flex-1 overflow-x-auto">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `chip !h-10 ${isActive ? "chip-active" : ""}`} data-testid={`master-nav-${n.id}`}>
                <n.icon size={15} /> <span className="hidden sm:inline">{n.label}</span>
              </NavLink>
            ))}
          </nav>
          <span className="caption hidden md:block truncate max-w-[180px]">{user?.email}</span>
          <button className="icon-btn" title="Sair" onClick={logout} data-testid="master-logout-button"><LogOut size={16} /></button>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
